import { Routes } from '@/router/routes'

import { AppPermissions } from '@/types/enums/permissions/permissions'
import { Middleware } from '@/types/enums/middleware/middleware'

export const alertsRoutes = [
  {
    path: '/alerts',
    name: Routes.Alerts,
    component: () => import('@/pages/contexts/portal/alerts/Index.vue'),
    meta: {
      pageTitle: 'Alerts',
      middleware: [
        Middleware.REQUIRES_AUTH,
        Middleware.TOGGLES_NAV_DRAWER,
      ],
      permission: AppPermissions.VIEW_ALERTS,
    },
  },
]
